import { ROUTER } from '@core/constants/router.constants';
import { TextContent } from '@modules/changeman/pages/text-content/text-content.model';
import { TextContentStore } from '@modules/changeman/pages/text-content/text-content.store';
import { useService } from '@policoders/di';
import { BreadcrumbService, FlashMessageService } from '@policoders/ds';
import { useEffect, useState } from 'react';

export const useTextContent = () => {
  const breadcrumb = useService<BreadcrumbService>('BreadcrumbService');
  const store = useService<TextContentStore>('TextContentStore');
  const [entity, setEntity] = useState<TextContent>(new TextContent());
  const [current, setCurrent] = useState<TextContent>();
  const [saving, setSaving] = useState<boolean>(false);
  const [loading_current, setLoading] = useState<boolean>(false);
  const flashMessage = useService<FlashMessageService>('FlashMessageService');

  useEffect(() => {
    breadcrumb.set([{ label: 'Início', value: ROUTER.CHANGEMAN.INDEX }]);
  }, [breadcrumb]);

  useEffect(() => {
    const sub = store.state$.subscribe(value => {
      if (loading_current !== value.loading_current) setLoading(value.loading_current);
      if (saving !== value.saving) setSaving(value.saving);
      if (current !== value.current) setCurrent(value.current);
      if (value.errors && value.errors.length > 0) {
        flashMessage.setMessage('error', JSON.stringify(value.errors));
      }
    });
    return () => {
      sub.unsubscribe();
    };
  }, [loading_current, saving, current, store, flashMessage]);

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    setEntity({
      ...entity,
      [name]: value,
    });
  };

  const handleSend = async () => {
    if (!entity.id || saving) {
      return;
    }

    const result = await store.add(entity);
    if (result) {
      flashMessage.setMessage('success', result);
      console.log('handleSend:', result);
    }
  };

  const handleReceive = async () => {
    if (!entity.name || saving) {
      return;
    }

    await store.getByName(entity.name);
  };

  const handleRemove = async () => {
    if (!entity?.name) return;

    if (window.confirm(`Excluir conteúdo retornado? ${entity.name}`)) {
      const result = await store.removeItem(entity.name);

      if (result) {
        flashMessage.setMessage('success', result);
        console.log('handleRemove:', result);
      }
    }
  };

  const downloadText = () => {
    if (!current?.content) return;
    const a = document.createElement('a');
    a.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(current.content);
    a.download = current.name || 'content.txt';
    a.click();
  };

  const downloadContent = () => {
    if (!current?.content) return;
    var a = document.createElement('a');
    a.href = 'data:application/octet-stream;base64,' + current.content;
    a.download = current.name;
    a.click();
  };

  return {
    current,
    entity,
    loading_current,
    saving,
    downloadText,
    downloadContent,
    handleInputChange,
    handleReceive,
    handleSend,
    handleRemove,
  };
};
